// Angular
import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';

// Local
import packageJson from '@package';
import { buildClassicStaticUrl } from '@shared/utils/classic-url.util';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  /**
   * The current date.
   * Used to display the copyright year in the footer.
   */
  currentDate = new Date();

  /**
   * The application version displayed in the footer.
   */
  appVersion = packageJson.version;

  /**
   * The legal/informational links shown in every page footer, matching the
   * Classic File & ServeXpress footer (Common/Footer.ascx). Terms & Conditions
   * points at the environment's Classic host, as the legacy footer does.
   */
  readonly footerLinks = [
    {
      label: 'About File & ServeXpress',
      url: 'https://www.fileandservexpress.com/about-us',
    },
    {
      label: 'Terms & Conditions',
      url: buildClassicStaticUrl('/agreement.htm?v=20200905'),
    },
    { label: 'Privacy', url: 'https://www.fileandservexpress.com/privacy' },
  ];
}
